





























import Vue from 'vue'
export default Vue.extend({
  props: {
    items: {
      type: Array,
      default() {
        return [
          {
            class: "",
            link: "#",
            text: "Link",
            icon: "link"
          }
        ]
      }
    },
    header: {
      type: Object,
      default() {
        return {
          show: true,
          title: "Menu"
        }
      }
    }
  }
})
